
const isLocal = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";

// In production (Vercel), default to Heroku if env var is missing.
// In development (Localhost), default to local backend.
export const API_BASE_URL = process.env.REACT_APP_API_URL || (isLocal ? "http://localhost:8000" : "https://financial-insights-graicells-59e453de2458.herokuapp.com");

export const GOOGLE_AUTH_URL = `${API_BASE_URL}/auth/login/google`;
export const GITHUB_AUTH_URL = `${API_BASE_URL}/auth/login/github`;
